import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { plainEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { PaymentMethod } from '@/features/dashboard/tourConfig/types/PaymentMethod.ts';

export const getPossiblePaymentsMethods = () => {
  return [
    {
      label: 'Płatność online',
      value: PaymentMethod.TPAY,
    },
    {
      label: 'Przelew bankowy',
      value: PaymentMethod.TRANSFER,
    },
    {
      label: 'Gotówka',
      value: PaymentMethod.CASH,
    },
  ];
};

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  [PaymentMethod.TPAY]: 'Płatność online',
  [PaymentMethod.TRANSFER]: 'Przelew bankowy',
  [PaymentMethod.CASH]: 'Gotówka',
};

/** Sposób zapłaty to kategoria, nie stan — kropka przy „Gotówce" nic nie niesie. */
export const paymentMethodTableConfig: EnumTableConfig = {
  [PaymentMethod.TPAY]: plainEnumConfig(
    paymentMethodLabels[PaymentMethod.TPAY],
  ),
  [PaymentMethod.TRANSFER]: plainEnumConfig(
    paymentMethodLabels[PaymentMethod.TRANSFER],
  ),
  [PaymentMethod.CASH]: plainEnumConfig(
    paymentMethodLabels[PaymentMethod.CASH],
  ),
};
